(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-quote-carousel"] && !Shopify.designMode) return;
  try {
    
  class HwQuoteCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hw-track]');
      this.dotsContainer = this.querySelector('[data-hw-dots]');
      this.dots = Array.from(this.querySelectorAll('[data-hw-dot]'));
      if (!this.track || this.dots.length === 0) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.hwDot);
          const card = this.track.children[index];
          if (card) {
            this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          }
        });
      });

      // Live sync: update dots every frame while scrolling - no debounce,
      // so the active dot moves with the swipe instead of after it.
      this.track.addEventListener(
        'scroll',
        () => {
          if (this._raf) return;
          this._raf = window.requestAnimationFrame(() => {
            this._raf = null;
            this.updateDots();
          });
        },
        { passive: true }
      );

      // Hide dots entirely when every card already fits in view (desktop).
      this.checkOverflow();
      this._resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this._resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    checkOverflow() {
      if (!this.dotsContainer) return;
      const fits = this.track.scrollWidth <= this.track.clientWidth + 1;
      this.dotsContainer.toggleAttribute('hidden', fits);
    }

    updateDots() {
      const cards = Array.from(this.track.children);
      if (cards.length === 0) return;
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let activeIndex = 0;
      let best = Infinity;
      cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft - this.track.offsetLeft + card.offsetWidth / 2;
        const d = Math.abs(cardCenter - center);
        if (d < best) {
          best = d;
          activeIndex = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }
  }

  if (!customElements.get('hw-quote-carousel')) {
    customElements.define('hw-quote-carousel', HwQuoteCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-reviews"] && !Shopify.designMode) return;
  try {
    
  class HwReviewsList extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-hw-load-more]');
      if (!this.button) return;
      this.button.addEventListener('click', () => {
        this.querySelectorAll('.hw-reviews__card[hidden]').forEach((item) => item.removeAttribute('hidden'));
        const more = this.querySelector('.hw-reviews__more');
        if (more) more.remove();
      });
    }
  }

  if (!customElements.get('hw-reviews-list')) {
    customElements.define('hw-reviews-list', HwReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
